import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../../../form/component/Checkbox'
import { WIDGET_LIST } from '../../../../constant/widgets'


const RoleWidget = ({ currentRole, toggleRoleWidgetAccess, saveRole }) => {
    if (!currentRole) {
        return null
    }
    const widgetList = WIDGET_LIST
    return (
        <div>
            Widget access<br/>
            {
                Object.entries(widgetList).map(([widgetId, widgetName]) => {
                    const hasWidgetAccess = currentRole.widgetList.indexOf(widgetId) !== -1
                    return (
                        <Checkbox
                            key={widgetId}
                            object={{ hasWidgetAccess }}
                            onChange={() => {
                                toggleRoleWidgetAccess(widgetId, !hasWidgetAccess)
                                saveRole()
                            }}
                            name="hasWidgetAccess">{widgetName}
                        </Checkbox>)
                })
            }
        </div>)
}


RoleWidget.propTypes = {
    currentRole: PropTypes.object,
    toggleRoleWidgetAccess: PropTypes.func.isRequired,
    saveRole: PropTypes.func.isRequired,
}

export default RoleWidget




// WEBPACK FOOTER //
// ./src/modules/security/component/manage/RoleWidget.js